<template>
  <div class="text-center" v-if="showDialog">
    <v-dialog v-model="showDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Timeslot Validation
        </v-card-title>

        <v-card-text class="text-center text-danger bespoke-margin">
          Please select a timeslot that is valid.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="$emit('closeDialog', 'showDialog')">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "CalValidation",
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>
